import { CONTACT_TYPE_PHONE } from '../defaults/ContactTypes';

/* Action Types */
export const ADD_NEW_GUEST = 'ADD_NEW_GUEST';
export const GUEST_DATA_CHANGE = 'GUEST_DATA_CHANGE';
export const REMOVE_GUEST = 'REMOVE_GUEST';
export const RESET_GUEST = 'RESET_GUEST';
export const SET_GUEST_MAIL_ERROR = 'SET_GUEST_MAIL_ERROR';
export const SET_GUEST_MOBILE_ERROR = 'SET_GUEST_MOBILE_ERROR';
export const SET_GUEST_NAME_ERROR = 'SET_GUEST_NAME_ERROR';
export const SET_GUEST_CONTACT_TYPE = 'SET_GUEST_CONTACT_TYPE';

/* Action Creators */

export function addNewGuest(guest) {
  return { type: ADD_NEW_GUEST, guest };
}

export function changeGuestData(guest) {
  return { type: GUEST_DATA_CHANGE, guest };
}

export function removeGuest(guestIndex) {
  return { type: REMOVE_GUEST, guestIndex };
}

export function resetGuest(guestIndex) {
  return { type: RESET_GUEST, guestIndex };
}

export function setGuestMailError(guestIndex, error) {
  return { type: SET_GUEST_MAIL_ERROR, guestIndex, error };
}

export function setGuestMobileError(guestIndex, error) {
  return { type: SET_GUEST_MOBILE_ERROR, guestIndex, error };
}

export function setGuestNameError(guestIndex, error) {
  return { type: SET_GUEST_NAME_ERROR, guestIndex, error };
}

export function setGuestContactType(guestIndex, contactType) {
  return { type: SET_GUEST_CONTACT_TYPE, guestIndex, contactType };
}

const INITIAL_STATE = {
  0: {
    contactType: CONTACT_TYPE_PHONE,
    guest: null,
    errors: {
      mail: null,
      mobile: null,
      name: null
    }
  }
}

/* Reducer */
export default function reducer(guests = INITIAL_STATE, action) {

  const { contactType, error, guest, guestIndex, type } = action;

  switch(type) {
    case ADD_NEW_GUEST:
      return {
        ...guests,
        [Object.keys(guests).length]: {
          ...INITIAL_STATE[0],
          contactType: guests[Object.keys(guests).length - 1].contactType
        }
      };
    case GUEST_DATA_CHANGE:
      return {
        ...guests,
        [guest.getIndex()]: {
          ...guests[guest.getIndex()],
          guest,
        },
      };
    case REMOVE_GUEST:
      let newGuests = { ...guests };
      delete newGuests[guestIndex];
      return newGuests;
    case RESET_GUEST:
      return {
        ...guests,
        [guestIndex]: {
          ...guests[guestIndex],
          guest: null
        }
      }
    case SET_GUEST_MAIL_ERROR:
      return {
        ...guests,
        [guestIndex]: {
          ...guests[guestIndex],
          errors: {
            ...guests[guestIndex].errors,
            mail: error,
          },
        },
      };
    case SET_GUEST_MOBILE_ERROR:
      return {
        ...guests,
        [guestIndex]: {
          ...guests[guestIndex],
          errors: {
            ...guests[guestIndex].errors,
            mobile: error,
          },
        },
      };
    case SET_GUEST_NAME_ERROR:
      return {
        ...guests,
        [guestIndex]: {
          ...guests[guestIndex],
          errors: {
            ...guests[guestIndex].errors,
            name: error,
          },
        },
      };
    case SET_GUEST_CONTACT_TYPE:
      return {
        ...guests,
        [guestIndex]: {
          ...guests[guestIndex],
          contactType,
        },
      };
    default:
      return guests;
  }

}



// WEBPACK FOOTER //
// ./src/ducks/GuestsDucks.js